// Media releases are their own Storyblok content type (`media_release`) that
// renders through the Article template. They live under /media and must never
// mix with Insights (`article`) content, in either direction.
export const ARTICLE_COMPONENT = 'article'
export const MEDIA_RELEASE_COMPONENT = 'media_release'

// Label used by the "article-type" datasource and by relatedContent bloks that
// pull items by type, kept so the /media listing keeps working unchanged.
export const MEDIA_RELEASE_TYPE = 'Media Release'

export function isMediaRelease(component: unknown): boolean {
  return component === MEDIA_RELEASE_COMPONENT
}

// The content type a related-articles query should stay inside of.
export function articleComponentFor(component: unknown): string {
  return isMediaRelease(component) ? MEDIA_RELEASE_COMPONENT : ARTICLE_COMPONENT
}

// Two stories belong together when they are both media releases or both insights.
export function isSameArticleFamily(component: unknown, otherComponent: unknown): boolean {
  return isMediaRelease(component) === isMediaRelease(otherComponent)
}

export function relatedArticlesCTA(component: unknown): { label: string; link: string } {
  return isMediaRelease(component)
    ? { label: 'View all media releases', link: '/media' }
    : { label: 'View all articles', link: '/insights/search' }
}

function isMediaReleaseLabel(label: unknown): boolean {
  return (
    typeof label === 'string' && label.trim().toLowerCase() === MEDIA_RELEASE_TYPE.toLowerCase()
  )
}

// Translates a relatedContent blok's pullItemsByType selection into the content
// type to query and the article_type values to filter on. "Media Release" maps
// to the media_release content type (which has no article_type field); anything
// else stays an article_type filter on the article content type.
export function pullItemsByTypeQuery(pullItemsByType: unknown[]): {
  component: string
  articleTypes: string[]
} {
  const labels = pullItemsByType.filter((label): label is string => typeof label === 'string')
  const articleTypes = labels.filter((label) => !isMediaReleaseLabel(label))
  const wantsMediaReleases = articleTypes.length < labels.length

  if (wantsMediaReleases && articleTypes.length === 0) {
    return { component: MEDIA_RELEASE_COMPONENT, articleTypes: [] }
  }
  return { component: ARTICLE_COMPONENT, articleTypes }
}
